import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=754c0c0b&scoped=true"
import script from "./discount.vue?vue&type=script&lang=js"
export * from "./discount.vue?vue&type=script&lang=js"
import style0 from "./discount.vue?vue&type=style&index=0&id=754c0c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c0c0b",
  null
  
)

export default component.exports